import { ControlBar } from '../ActivityComponents/ControlBar/ControlBar';
import { StyledWorksheetActivity } from './WorksheetActivity.styled';
import { useExpandedScreenContext } from '@/shared/ThemeDetail/ExpandedScreen/ExpandedScreenContext';
import { useContext } from 'react';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import useIsMobile from '@/hooks/useIsMobile';

export default function WorksheetActivity({ activity }) {
  const fullscreenContext = useContext(FullscreenContext);
  const expandedScreenContext = useExpandedScreenContext();
  const isIOS = useIsMobile('apple.device');

  if (!activity?.data) {
    return null;
  }

  const file =
    activity.type == 'worksheet' ||
    activity.type == 'pictureDictionary' ||
    activity.data?.subType == 'pdf'
      ? activity.data.file
      : activity.data.storyPdf;

  return (
    <StyledWorksheetActivity
      className={fullscreenContext.state.isFullscreen ? 'fullscreen' : ''}
    >
      {isIOS ? (
        <embed
          className="iframe ios"
          key={activity.id + ' - ' + expandedScreenContext.state?.active}
          src={file}
          type="application/pdf"
        />
      ) : (
        <>
          <iframe
            className="iframe"
            key={activity.id + ' - ' + expandedScreenContext.state?.active}
            src={file}
          />
          <ControlBar />
        </>
      )}
    </StyledWorksheetActivity>
  );
}
